import { useUserSubscription } from '../useUserSubscription';
import { useHasMediaProcessorSupport } from '../useHasMediaProcessorSupport/useHasMediaProcessorSupport';
import { useService } from '../useService';

/**
 * All the criteria for virtual background to be enabled
 */
export const useIsVirtualBackgroundEnabled = (): boolean => {
  const { isPaidUser } = useUserSubscription();
  const hasMediaProcessorSupport = useHasMediaProcessorSupport();
  const isProvider = useService('$context') === 'provider';

  return isPaidUser && hasMediaProcessorSupport && isProvider;
};
